import React, {useState, useEffect}from 'react'
//redux stuff
import { useSelector, useDispatch} from 'react-redux';
//firebase stuff
import {firebase} from './firebase';
import {collectionRef, db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import {getAuth, createUserWithEmailAndPassword,signOut,signInWithEmailAndPassword,updateProfile} from 'firebase/auth';
import "./css/CurrentStreak.css"

const CurrentStreak = React.memo(props => {
     const auth = getAuth();
     const [streakNumber, setStreakNumber] = useState('');
     const [loading, setLoading] = useState(false);


     //redux
     const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);
     //create the DB paths to put the data into
     const streakRef = collection(db,"users",reduxUserID,"streak");


     useEffect(() => {
          //call this in useEffect but we were getting a render, creating two documents for the streak number
          getStreakData();
        }, [reduxUserID])


     const getStreakData = () => {
          setLoading(true);

          const documents = getDocs(streakRef)
          .then((snapshot)=>{
              var dataGrab = new Array(); //which becomes an object for some reason
              snapshot.docs.forEach((doc)=>{
                  dataGrab.push({...doc.data(),id:doc.id})
              })
              const dbDataARRAY = Object.values(dataGrab); // Object.values() converts it to an array()

              //if theyre brand new, check if theres a rally number in their user DB. if not, set state to zero
              //else, set the state to whatever number is returned
              if(dbDataARRAY.length == 0){
               addDoc(streakRef,{
                    streakNumber: 0,
                  }).then(() => {
                    setStreakNumber(0);
                    setLoading(false);
                  });
              }
              else{
                    setStreakNumber(dbDataARRAY[0].streakNumber);
                    setLoading(false);
              }
             
          })//end then()
        }////end getRallyData()

    

        var comment;
        if(streakNumber == 0){
          comment = "1 day won't kill you";
        }
        else if(streakNumber == 1){
          comment = "Ok it's a start";
        }
        else if(streakNumber >= 2){
          comment = "days in a row ";
        }     
     

     return (
          <div className='currentStreakContainer'>
              <div className='headerBar'>Your Daily Streak</div>
              <p className={loading ? 'dayNumber streakLoading' : 'dayNumber'}> {streakNumber} </p>
              <p className='days'>{comment}</p>
          </div>
     )
})

export default CurrentStreak
